/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Reusable_WorkspacesInputs */



/**
* | output |
* | --- |
* | "Create reusable project workspaces" |
*
* @param {Onboarding_Usage_Reusable_WorkspacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_reusable_workspaces = /** @type {((inputs?: Onboarding_Usage_Reusable_WorkspacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Reusable_WorkspacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederverwendbare Projekt-Arbeitsbereiche erstellen")
	return /** @type {LocalizedString} */ ("Create reusable project workspaces")
});